"use strict";

document.addEventListener("DOMContentLoaded", () => {
  /********************************
   * Vars
   *******************************/
  const html = document.querySelector("html");
  const body = document.querySelector("body");
  const screenWidth = window.innerWidth;

  /********************************
   * Klaviyo Form
   *******************************/
  const klaviyoFormGroup = document.querySelectorAll(".klaviyo-form");

  if (klaviyoFormGroup.length) {
    function submitKlaviyoForm(
      e,
      listId,
      companyId,
      klaviyoForm,
      klaviyoFormError,
      klaviyoFormSuccessful,
    ) {
      e.preventDefault();
      const emailInput = klaviyoForm.querySelector(".input-email");
      if (!emailInput.value) return;

      fetch(
        "https://a.klaviyo.com/client/subscriptions/?company_id=" + companyId,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            revision: "2024-07-15",
          },
          body: JSON.stringify({
            data: {
              type: "subscription",
              attributes: {
                profile: {
                  data: {
                    type: "profile",
                    attributes: {
                      email: emailInput.value,
                    },
                  },
                },
              },
              relationships: {
                list: {
                  data: {
                    type: "list",
                    id: listId,
                  },
                },
              },
            },
          }),
        },
      )
        .then(function (response) {
          return response.text();
        })
        .then(function (data) {
          console.log(`data, ${data}`);
          emailInput.value = "";
          klaviyoFormSuccessful.style.display = "block";
        })
        .catch(function (error) {
          console.error("Error:", error);
          klaviyoFormError.style.display = "block";
        });
    }

    klaviyoFormGroup.forEach((klaviyoFormItem) => {
      const listId = klaviyoFormItem.dataset.list;
      const companyId = klaviyoFormItem.dataset.companyId;
      const klaviyoForm = klaviyoFormItem.querySelector("form");
      const klaviyoFormError =
        klaviyoFormItem.querySelector(".subscribe-error");
      const klaviyoFormSuccessful = klaviyoFormItem.querySelector(
        ".subscribe-successful",
      );

      klaviyoForm.addEventListener("submit", (e) =>
        submitKlaviyoForm(
          e,
          listId,
          companyId,
          klaviyoForm,
          klaviyoFormError,
          klaviyoFormSuccessful,
        ),
      );
    });
  }

  /********************************
   * Featured products
   *******************************/
  const sectionFeaturedProducts = document.querySelectorAll(".featured-products");

  if (sectionFeaturedProducts.length) {
    /*function initializeSlider(slider, slideLength) {
      if (screenWidth >= 1200 && slideLength >= 4) {
        startSlider(slider);
      } else if (screenWidth >= 992 && screenWidth <= 1199 && slideLength > 3) {
        startSlider(slider);
      } else if (screenWidth >= 768 && screenWidth <= 991 && slideLength > 2) {
        startSlider(slider);
      } else if (screenWidth <= 767 && slideLength > 1) {
        startSlider(slider);
      }
    }*/

    function startSlider(sliderInit) {
      console.log('init card slider')
      sliderInit.closest(".slider-container").classList.add("slider-init");

      new Swiper(sliderInit, {
        lazy: true,
        loop: true,
        spaceBetween: 16,
        slidesPerView: 'auto',
      });
    }

    sectionFeaturedProducts.forEach((section) => {
      const slider = section.querySelector(".slider_init");
      /*const slideLength = slider.querySelectorAll(".swiper-slide").length;*/

      startSlider(slider);
    });
  }

  /********************************
   * Global Video Initialization
   *******************************/
  const globalVideoElements = document.querySelectorAll(
    "global-video:not(.is-initialized)",
  );

  if (globalVideoElements.length) {
    const initGlobalVideo = (container) => {
      const lazyVideos = container.querySelectorAll(
        ".js-global-video-lazyload",
      );
      const allVideos = container.querySelectorAll("video");
      const observerConfig = {
        rootMargin: "250px",
        threshold: 0.01,
      };

      const loadVideoSource = (video) => {
        const poster = video.getAttribute("data-poster");
        if (poster) {
          video.setAttribute("poster", poster);
          video.removeAttribute("data-poster");
        }

        const sources = video.querySelectorAll("source");
        sources.forEach((source) => {
          const src = source.getAttribute("data-src");
          if (src) {
            source.setAttribute("src", src);
            source.removeAttribute("data-src");
          }
        });

        video.load();

        video.addEventListener(
          "loadeddata",
          () => {
            if (video.hasAttribute("autoplay")) {
              video.play().catch((err) => {
                console.warn("Autoplay was prevented:", err);
              });
            }
          },
          { once: true },
        );
      };

      if (lazyVideos.length > 0 && "IntersectionObserver" in window) {
        const observer = new IntersectionObserver(
          (entries, observerInstance) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                loadVideoSource(entry.target);
                observerInstance.unobserve(entry.target);
              }
            });
          },
          observerConfig,
        );

        lazyVideos.forEach((v) => observer.observe(v));
      } else {
        allVideos.forEach((v) => loadVideoSource(v));
      }

      container.addEventListener("video:play", () =>
        allVideos.forEach((v) => v.play()),
      );
      container.addEventListener("video:pause", () =>
        allVideos.forEach((v) => v.pause()),
      );
      container.addEventListener("video:mute", () =>
        allVideos.forEach((v) => (v.muted = true)),
      );
      container.addEventListener("video:unmute", () =>
        allVideos.forEach((v) => (v.muted = false)),
      );

      container.addEventListener("video:toggle:sound", () => {
        allVideos.forEach((v) => {
          v.muted = !v.muted;
        });
      });

      container.addEventListener("video:toggle:playback", () => {
        allVideos.forEach((v) => {
          v.paused ? v.play() : v.pause();
        });
      });

      container.classList.add("is-initialized");
    };

    globalVideoElements.forEach((container) => initGlobalVideo(container));
  }

  /********************************
   * Accordion: FAQ
   *******************************/
  const accordionGroup = document.querySelectorAll(".accordion-wrap");

  if (accordionGroup.length >= 1) {
    accordionGroup.forEach((accordion) => {
      const isAccordionDisabled = () => {
        const width = window.innerWidth;
        if (width < 992 && accordion.classList.contains("show-all-on-mobile")) {
          return true;
        }

        if (width > 992 && accordion.classList.contains("accordion-mobile-only")) {
          return true;
        }

        return false;
      };

      if (accordion.classList.contains("open-first-child")) {
        setTimeout(() => {
          if (isAccordionDisabled()) return;

          const accordionItem = accordion.querySelector(".accordion-item");
          if (!accordionItem) return;

          const customPadding = +accordionItem.dataset.descriptionPadding || 24;
          const accordionContent = accordionItem.querySelector(
            ".accordion-description",
          );

          accordionItem.classList.add("active");
          accordionContent.style.height =
            accordionItem.querySelector(".accordion-inner-content")
              .scrollHeight +
            customPadding +
            "px";
        }, 1300);
      }

      if (accordion.classList.contains("open-all-child")) {
        setTimeout(() => {
          const accordionItems = accordion.querySelectorAll(".accordion-item");
          accordionItems.forEach((accordionItem) => {
            const customPadding =
              +accordionItem.dataset.descriptionPadding || 24;
            const accordionContent = accordionItem.querySelector(
              ".accordion-description",
            );

            accordionItem.classList.add("active");
            accordionContent.style.height =
              accordionContent.querySelector(".accordion-inner-content")
                .scrollHeight +
              customPadding +
              "px";
          });
        }, 1300);
      }

      accordion.addEventListener("click", function ({ target }) {
        if (isAccordionDisabled()) {
          return;
        }

        const accordionItem = target.closest(".accordion-item");
        if (!accordionItem || target.closest(".accordion-description")) {
          return;
        }

        const customPadding = +accordionItem.dataset.descriptionPadding || 24;
        const accordionContent = accordionItem.querySelector(".accordion-description",);

        if (accordionItem.classList.contains("active")) {
          accordionItem.classList.remove("active");
          accordionContent.style.height = 0 + "px";
        } else {
          accordionItem.classList.add("active");
          accordionContent.style.height =
            accordionContent.querySelector(".accordion-inner-content").scrollHeight + customPadding + "px";
        }
      });
    });
  }

  /********************************
   * How It Works
   *******************************/
  const howItWorks = document.querySelectorAll(".how-it-works");

  if (howItWorks.length) {
    function initializeSlider(slider, slideLength, hasScrollbar) {
      if (screenWidth >= 768 && screenWidth <= 991 && slideLength > 2) {
        startSlider(slider, hasScrollbar);
      } else if (screenWidth <= 767 && slideLength > 1) {
        startSlider(slider, hasScrollbar);
      }
    }

    function startSlider(sliderInit, hasScrollbar) {
      sliderInit.closest(".slider-wrap").classList.add("slider-init");

      const swiperConfig = {
        lazy: true,
        spaceBetween: 15,
        slidesPerView: 1.15,
        breakpoints: {
          768: {
            slidesPerView: 2.1,
          },
        },
      };

      if (hasScrollbar) {
        swiperConfig.scrollbar = {
          draggable: true,
          el: sliderInit.closest(".slider-wrap").querySelector(".swiper-scrollbar"),
        };
      }

      new Swiper(sliderInit, swiperConfig);
    }

    howItWorks.forEach((section) => {
      const slider = section.querySelector(".slider_init");
      if (!slider) return;

      const slideLength = slider.querySelectorAll(".swiper-slide").length;
      const hasScrollbar = !!section.querySelector(".swiper-scrollbar");

      initializeSlider(slider, slideLength, hasScrollbar);
    });
  }

  /********************************
   * Media Slider
   *******************************/
  const sectionMediaSlider = document.querySelectorAll(".media-slider");

  if (sectionMediaSlider.length) {
    function startSlider(sliderInit) {
      sliderInit.closest(".slider-wrap").classList.add("slider-init");

      new Swiper(sliderInit, {
        lazy: true,
        slidesPerView: 1.1,
        spaceBetween: 10,

        breakpoints: {
          768: {
            spaceBetween: 16,
            slidesPerView: 1.4,
          },
          992: {
            spaceBetween: 24,
            slidesPerView: 2,
          },
          1200: {
            spaceBetween: 33,
            slidesPerView: 2,
          },
        },

        scrollbar: {
          draggable: true,
          el: ".swiper-scrollbar",
        },
      });
    }

    sectionMediaSlider.forEach((section) => {
      startSlider(section.querySelector(".slider_init"));
    });
  }

  /********************************
   * Single Product
   *******************************/
  const singleProduct = document.querySelectorAll(".single-product");

  function getSelectedVariantMediaId(section) {
    const variantData = section.querySelector("variant-selects [data-selected-variant]",);
    if (!variantData?.textContent?.trim()) return null;

    try {
      const variant = JSON.parse(variantData.textContent);
      return variant?.featured_media?.id ?? variant?.featured_image?.id ?? null;
    } catch {
      return null;
    }
  }

  function scrollProductSliderToMedia(section, mediaId) {
    if (!section || !mediaId) return;

    const mainEl = section.querySelector(".slider_main_init");
    const swiper = mainEl?.swiper;
    if (!swiper) return;

    const slides = mainEl.querySelectorAll(".swiper-slide[data-media-id]");
    let targetIndex = -1;

    slides.forEach((slide, index) => {
      if (slide.dataset.mediaId === String(mediaId)) {
        targetIndex = index;
      }
    });

    if (targetIndex >= 0) {
      if (swiper.params.loop) {
        swiper.slideToLoop(targetIndex, 0);
      } else {
        swiper.slideTo(targetIndex, 0);
      }
    }
  }

  const initializeUGC = (ugcSliderElement) => {
    if (ugcSliderElement.dataset.ugcInitialized === "1") return;
    ugcSliderElement.dataset.ugcInitialized = "1";

    const sectionElement = ugcSliderElement.closest(".single-product");
    if (!sectionElement) return;

    const popupElement = sectionElement.querySelector(".ugc-popup");
    const videoBoxElement = popupElement
      ? popupElement.querySelector(".video-box")
      : null;

    const slideElements = Array.from(
      ugcSliderElement.querySelectorAll(".swiper-slide[data-ugc-item]"),
    );
    const slideCount = slideElements.length;

    if (!popupElement || !videoBoxElement || slideCount === 0) return;

    let currentIndex = 0;

    const stopAndClearPopupVideo = () => {
      const videoElement = videoBoxElement.querySelector("video");
      if (videoElement) {
        try {
          videoElement.pause();
        } catch (e) {}
      }
      videoBoxElement.innerHTML = "";
    };

    const openPopup = () => {
      popupElement.classList.add("show");
      popupElement.setAttribute("aria-hidden", "false");
    };

    const closePopup = () => {
      stopAndClearPopupVideo();
      popupElement.classList.remove("show");
      popupElement.setAttribute("aria-hidden", "true");
    };

    const renderAndPlayVideoByIndex = (index) => {
      const normalizedIndex = ((index % slideCount) + slideCount) % slideCount;
      currentIndex = normalizedIndex;

      const slideElement = slideElements[normalizedIndex];
      const videoUrl = slideElement.dataset.videoUrl;
      const posterUrl = slideElement.dataset.poster;

      stopAndClearPopupVideo();

      if (!videoUrl) return;

      const videoElement = document.createElement("video");
      videoElement.className = "ugc-popup-video";
      videoElement.playsInline = true;
      videoElement.preload = "metadata";
      videoElement.muted = false;
      videoElement.autoplay = true;
      videoElement.controls = true;
      /*videoElement.controls = false;
      videoElement.setAttribute('controlslist', 'nodownload noplaybackrate');*/

      if (posterUrl) videoElement.setAttribute("poster", posterUrl);

      const sourceElement = document.createElement("source");
      sourceElement.src = videoUrl;
      sourceElement.type = "video/mp4";

      videoElement.appendChild(sourceElement);
      videoBoxElement.appendChild(videoElement);

      const playPromise = videoElement.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(() => {});
      }
    };

    const openPopupFromSlide = (slideElement) => {
      const indexAttr = slideElement.getAttribute("data-index");
      const index = indexAttr
        ? parseInt(indexAttr, 10)
        : slideElements.indexOf(slideElement);
      if (Number.isNaN(index) || index < 0) return;

      openPopup();
      renderAndPlayVideoByIndex(index);
    };

    const previousButton = popupElement.querySelector(".video-prev");
    const nextButton = popupElement.querySelector(".video-next");
    const closeButton = popupElement.querySelector(".popup-close");
    const popupOverflow = popupElement.querySelector(".ugc-popup-overflow");

    if (previousButton) {
      previousButton.addEventListener("click", (event) => {
        event.preventDefault();
        renderAndPlayVideoByIndex(currentIndex - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener("click", (event) => {
        event.preventDefault();
        renderAndPlayVideoByIndex(currentIndex + 1);
      });
    }

    if (closeButton || popupOverflow) {
      popupOverflow.addEventListener("click", (event) => {
        event.preventDefault();
        closePopup();
      });

      closeButton.addEventListener("click", (event) => {
        event.preventDefault();
        closePopup();
      });
    }

    popupElement.addEventListener("click", (event) => {
      if (event.target === popupElement) closePopup();
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && popupElement.classList.contains("show"))
        closePopup();
    });

    if (slideCount > 2) {
      ugcSliderElement.closest(".ugc-wrap")?.classList.add("slider-active");

      new Swiper(ugcSliderElement, {
        slidesPerView: 2.3,
        spaceBetween: 8,
        threshold: 8,

        on: {
          click(swiper, event) {
            const slideElement = event.target.closest(
              ".swiper-slide[data-ugc-item]",
            );
            if (slideElement) openPopupFromSlide(slideElement);
          },
        },
      });
    } else {
      ugcSliderElement.addEventListener("click", (event) => {
        const slideElement = event.target.closest(
          ".swiper-slide[data-ugc-item]",
        );
        if (slideElement) openPopupFromSlide(slideElement);
      });
    }
  };

  if (singleProduct.length >= 1) {
    singleProduct.forEach((section) => {
      /********************************
       * Slider (optional)
       *******************************/
      const mainEl = section.querySelector(".slider_main_init");
      const thumbsEl = section.querySelector(".slider_thumbs_init");

      let thumbsSwiper = null;

      if (mainEl && thumbsEl) {
        const slidesCount = mainEl.querySelectorAll(".swiper-slide").length;

        if (slidesCount > 1) {
          mainEl.closest(".product-media").classList.add("slider-init");

          thumbsSwiper = new Swiper(thumbsEl, {
            spaceBetween: 10,
            slidesPerView: 6,
            watchSlidesProgress: true,
            slideToClickedSlide: true,
            hashNavigation: true,
            loop: true,
            navigation: {
              nextEl: ".slider_thumbs_init .swiper-btn.btn-next",
              prevEl: ".slider_thumbs_init .swiper-btn.btn-prev",
            },
          });

          new Swiper(mainEl, {
            spaceBetween: 14,
            slidesPerView: 1.1,

            breakpoints: {
              768: {
                slidesPerView: 1,
              },
            },

            thumbs: {
              swiper: thumbsSwiper,
            },

            scrollbar: {
              draggable: true,
              el: ".swiper-scrollbar",
            },
          });

          const initialMediaId = getSelectedVariantMediaId(section);
          if (initialMediaId) {
            scrollProductSliderToMedia(section, initialMediaId);
          }
        }
      }

      /********************************
       * Popups
       *******************************/
      const closeAllPopups = () => {
        section.querySelectorAll(".info-popup").forEach((p) => {
          p.classList.remove("show");
          p.setAttribute("aria-hidden", "true");
        });
      };

      const openPopupByType = (type) => {
        if (!type) return;

        const popup = section.querySelector(`.info-popup.type-${type}`);
        if (!popup) return;

        closeAllPopups();
        popup.classList.add("show");
        popup.setAttribute("aria-hidden", "false");
      };

      section.addEventListener("click", (e) => {
        const trigger = e.target.closest(".popup-trigger");

        if (trigger) {
          const typeClass = [...trigger.classList].find((c) =>
            c.startsWith("type-"),
          );
          const type = typeClass?.replace("type-", "");
          openPopupByType(type);
          return;
        }

        if (
          e.target.closest(".popup-close") ||
          e.target.closest(".popup-overflow")
        ) {
          closeAllPopups();
          return;
        }

        const popup = e.target.closest(".info-popup");
        if (popup && e.target === popup) closeAllPopups();
      });

      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") closeAllPopups();
      });

      /********************************
       * UGC
       *******************************/
      const ugcSliderElement = section.querySelector(".ugc_init");
      if (ugcSliderElement) initializeUGC(ugcSliderElement);
    });
  }

  /********************************
   * Single Product + Sticky Product visibility
   *******************************/
  const stickyProduct = document.querySelector(".sticky-product");

  if (singleProduct.length >= 1 && stickyProduct) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const shouldShow =
            !entry.isIntersecting && entry.boundingClientRect.top < 0;

          stickyProduct.classList.toggle("show", shouldShow);
        });
      },
      {
        threshold: 0,
        root: null,
      },
    );

    singleProduct.forEach((section) => {
      const trigger = section.querySelector(".button-and-quantity");

      if (trigger) {
        io.observe(trigger);
      } else {
        io.observe(section);
      }
    });
  }

  /********************************
   * Custom Select
   *******************************/
  function closeAllSelects(currentElement) {
    const allItems = document.querySelectorAll(".select-items");
    const allSelected = document.querySelectorAll(".select-selected");

    allSelected.forEach((el, index) => {
      if (currentElement !== el) {
        el.classList.remove("is-active");
        if (allItems[index]) allItems[index].classList.add("select-hide");
      }
    });
  }

  function initCustomSelects(root) {
    const target = root || document;

    target.querySelectorAll(".select-selected").forEach((el) => el.remove());
    target.querySelectorAll(".select-items").forEach((el) => el.remove());

    const customSelects = target.querySelectorAll(".custom-select");
    if (!customSelects.length) return;

    customSelects.forEach((container) => {
      const selectElement = container.querySelector("select");
      if (!selectElement) return;

      const selectedDisplay = document.createElement("div");
      selectedDisplay.className = "select-selected";
      selectedDisplay.innerHTML =
        selectElement.options[selectElement.selectedIndex].innerHTML;
      container.appendChild(selectedDisplay);

      const itemsContainer = document.createElement("div");
      itemsContainer.className = "select-items select-hide";

      Array.from(selectElement.options).forEach((option, index) => {
        const optionDiv = document.createElement("div");
        optionDiv.innerHTML = option.innerHTML;

        if (index === selectElement.selectedIndex) {
          optionDiv.classList.add("same-as-selected");
        }

        optionDiv.addEventListener("click", function () {
          selectElement.selectedIndex = index;
          selectElement.dispatchEvent(new Event("input", { bubbles: true }));
          selectElement.dispatchEvent(new Event("change", { bubbles: true }));

          selectedDisplay.innerHTML = this.innerHTML;

          const prevSelected =
            itemsContainer.querySelector(".same-as-selected");
          if (prevSelected) prevSelected.classList.remove("same-as-selected");
          this.classList.add("same-as-selected");

          selectedDisplay.click();
        });

        itemsContainer.appendChild(optionDiv);
      });

      container.appendChild(itemsContainer);

      selectedDisplay.addEventListener("click", function (e) {
        e.stopPropagation();
        closeAllSelects(this);
        this.nextSibling.classList.toggle("select-hide");
        this.classList.toggle("is-active");
      });
    });
  }

  initCustomSelects();

  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    const variantSelects = document.querySelector(
      `variant-selects[data-section="${data.sectionId}"]`,
    );
    if (variantSelects) initCustomSelects(variantSelects);

    const section = document.querySelector(
      `.single-product[data-section="${data.sectionId}"]`,
    );
    if (section) {
      const mediaId =
        data.variant?.featured_media?.id ?? data.variant?.featured_image?.id;
      if (mediaId) scrollProductSliderToMedia(section, mediaId);
    }
  });

  document.addEventListener("click", () => closeAllSelects());

  /********************************
   * RTX Subscription Price Sync
   *******************************/
  function applyOnetimePriceToElement(priceEl, onetimePrice) {
    priceEl.classList.remove("price--on-sale", "price--show-badge", "price--no-compare");

    const regularPrice = priceEl.querySelector(
      ".price__regular .price-item--regular",
    );
    const salePrice = priceEl.querySelector(".price__sale .price-item--sale");
    const saleRegular = priceEl.querySelector(
      ".price__sale .price-item--regular",
    );
    const badge = priceEl.querySelector(".badge.price__badge-sale");

    if (regularPrice) regularPrice.textContent = onetimePrice;
    if (salePrice) salePrice.textContent = onetimePrice;
    if (saleRegular) saleRegular.textContent = "";
    if (badge) badge.style.display = "none";
  }

  function applyRtxPriceUpdate(detail) {
    const {
      productFormId,
      isSubscription,
      subscriptionPrice,
      onetimePrice,
      savingsLabel,
    } = detail;
    const productForm = document.getElementById(productFormId);
    if (!productForm) return;
    const section = productForm.closest(".single-product");
    if (!section) return;

    section.querySelectorAll(".js-rtx-price").forEach((el) => {
      el.textContent = isSubscription ? subscriptionPrice : onetimePrice;
    });
    document
      .querySelectorAll(".sticky-product .js-rtx-price--sticky")
      .forEach((el) => {
        el.textContent = isSubscription ? subscriptionPrice : onetimePrice;
      });

    section.querySelectorAll(".price-box").forEach((box) => {
      const priceEl = box.querySelector(".price");
      if (!priceEl) return;

      if (isSubscription) {
        if (!box.dataset.rtxOriginalHtml) {
          box.dataset.rtxOriginalHtml = box.innerHTML;
        }

        const hasDiscount = !!savingsLabel;

        priceEl.classList.toggle("price--on-sale", hasDiscount);
        priceEl.classList.toggle("price--show-badge", hasDiscount);
        priceEl.classList.toggle("price--no-compare", !hasDiscount);

        const regularItem = priceEl.querySelector(
          ".price__sale .price-item--regular",
        );
        const saleItem = priceEl.querySelector(
          ".price__sale .price-item--sale",
        );
        const badge = priceEl.querySelector(".badge.price__badge-sale");

        if (regularItem)
          regularItem.textContent = hasDiscount ? onetimePrice : "";
        if (saleItem) saleItem.textContent = subscriptionPrice;
        if (badge) {
          badge.textContent = savingsLabel || "";
          badge.style.display = hasDiscount ? "" : "none";
        }
      } else {
        if (box.dataset.rtxOriginalHtml) {
          box.innerHTML = box.dataset.rtxOriginalHtml;
        } else {
          applyOnetimePriceToElement(priceEl, onetimePrice);
        }
      }
    });
  }

  function clearRtxPriceDisplay(productFormId) {
    const productForm = document.getElementById(productFormId);
    if (!productForm) return;
    const section = productForm.closest(".single-product");
    if (!section) return;

    section.querySelectorAll(".js-rtx-price").forEach((el) => {
      el.textContent = el.dataset.basePrice || "";
    });
    document
      .querySelectorAll(".sticky-product .js-rtx-price--sticky")
      .forEach((el) => {
        el.textContent = el.dataset.basePrice || "";
      });
    section.querySelectorAll(".price-box").forEach((box) => {
      box.removeAttribute("data-rtx-original-html");
      const priceEl = box.querySelector(".price");
      if (!priceEl) return;
      priceEl.classList.remove("price--on-sale", "price--show-badge", "price--no-compare");
    });
  }

  document.addEventListener("rtx:price-update", ({ detail }) =>
    applyRtxPriceUpdate(detail),
  );
  document.addEventListener("rtx:widget-hidden", ({ detail }) =>
    clearRtxPriceDisplay(detail.productFormId),
  );

  if (window._rtxPriceState) {
    Object.values(window._rtxPriceState).forEach((state) => {
      if (!state) return;
      if (state.type === "update") applyRtxPriceUpdate(state.detail);
      else if (state.type === "hidden")
        clearRtxPriceDisplay(state.productFormId);
    });
  }

  /********************************
   * Collection page
   *******************************/
  const collectionPage = document.querySelector(".collection-page");

  if (collectionPage) {
    const isFilterTrigger = collectionPage.querySelector(".filter-trigger");
    const collectionsGrid = collectionPage.querySelector(".collections-grid");
    const collectionOverlay = collectionPage.querySelector(
      ".collection-overlay",
    );
    const facetFiltersForm = collectionPage.querySelector(
      ".facet-filters-form",
    );
    const triggerClose = collectionPage.querySelector("button.trigger-close");

    if (!isFilterTrigger || !collectionsGrid || !facetFiltersForm) return;

    function setFiltersOpen(isOpen) {
      isFilterTrigger.classList.toggle("active", isOpen);
      collectionsGrid.classList.toggle("is-filter", isOpen);

      if (!collectionOverlay) return;

      if (window.innerWidth < 991 && isOpen) {
        collectionOverlay.classList.add("show");
        handleScroll();
      } else {
        collectionOverlay.classList.remove("show");
      }
    }

    function handleScroll() {
      if (window.innerWidth >= 991) {
        facetFiltersForm.style.position = "";
        facetFiltersForm.classList.remove("is-bottom");
        return;
      }

      const sectionRect = collectionsGrid.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      if (sectionRect.bottom <= windowHeight) {
        facetFiltersForm.classList.add("is-bottom");
        facetFiltersForm.style.position = "absolute";
        facetFiltersForm.style.bottom = "0";
      } else {
        facetFiltersForm.classList.remove("is-bottom");
        facetFiltersForm.style.position = "fixed";
        facetFiltersForm.style.bottom = "0";
      }
    }

    isFilterTrigger.addEventListener("click", () => {
      setFiltersOpen(!collectionsGrid.classList.contains("is-filter"));
    });

    if (triggerClose) {
      triggerClose.addEventListener("click", () => setFiltersOpen(false));
    }

    if (collectionOverlay) {
      collectionOverlay.addEventListener("click", () => setFiltersOpen(false));
    }

    function closeFilterPanel() {
      if (window.innerWidth >= 991) return;
      setFiltersOpen(false);
    }

    setFiltersOpen(window.innerWidth > 980);

    collectionPage.querySelectorAll(".trigger-clear-filter").forEach((el) => {
      el.addEventListener("click", closeFilterPanel);
    });

    if (facetFiltersForm) {
      facetFiltersForm.addEventListener("change", (e) => {
        if (e.target.matches('input[type="checkbox"]')) {
          closeFilterPanel();
        }
      });
    }

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", () => {
      if (window.innerWidth >= 991) {
        facetFiltersForm.classList.remove("is-bottom");
        facetFiltersForm.style.position = "";
        collectionOverlay.classList.remove("show");
      }
      handleScroll();
    });

    handleScroll();
  }

  /*************************
   Collection: Product Popup
   *************************/
  const productPopup = document.getElementById("product-popup");

  if (productPopup) {
    const popupOverlay = productPopup.querySelector(".product-popup-overlay");
    const popupClose = productPopup.querySelector(".product-popup-close");
    const popupPanel = productPopup.querySelector(".product-popup-panel");
    const popupImg = productPopup.querySelector(".product-popup-img");
    const popupBadge = productPopup.querySelector(".product-popup-badge");
    const popupTitle = productPopup.querySelector(".product-popup-title");
    const popupSubtitle = productPopup.querySelector(".product-popup-subtitle");
    const popupPriceEls = productPopup.querySelectorAll(
      ".product-popup-price-text",
    );
    const popupVariantInput = productPopup.querySelector(
      ".product-popup-variant-id",
    );
    const popupSubscription = productPopup.querySelector(
      ".product-popup-subscription",
    );
    const popupForm = productPopup.querySelector("#product-popup-cart-form");
    const popupAddedName = productPopup.querySelector(
      ".product-popup-added-name",
    );
    let addedMessageTimer = null;

    const RETEXTION_APP_ID = "5859381";

    function openPopup() {
      productPopup.setAttribute("aria-hidden", "false");
      productPopup.classList.add("is-open");
      body.style.overflow = "hidden";
      popupPanel.focus();
    }

    function closePopup() {
      productPopup.classList.remove("is-open");
      productPopup
        .querySelector(".product-popup-added-message")
        ?.classList.remove("show");
      productPopup.setAttribute("aria-hidden", "true");
      body.style.overflow = "";
      popupSubscription.innerHTML = "";
      clearTimeout(addedMessageTimer);
    }

    function showAddedMessage(title) {
      const addedMessage = productPopup.querySelector(
        ".product-popup-added-message",
      );
      if (popupAddedName) popupAddedName.textContent = title;
      if (addedMessage) addedMessage.classList.add("show");
      clearTimeout(addedMessageTimer);
      addedMessageTimer = setTimeout(() => {
        if (addedMessage) addedMessage.classList.remove("show");
        closePopup();
      }, 500);
    }

    function setPopupPrice(price) {
      popupPriceEls.forEach((el) => {
        el.textContent = price;
      });
    }

    function initRtxWidget(product, variantId) {
      if (typeof customElements.get("purchase-options") === "undefined") return;

      const sellingPlanGroups = (product.selling_plan_groups || []).filter(
        (g) => g.app_id === RETEXTION_APP_ID,
      );

      if (!sellingPlanGroups.length) return;

      const currentVariant =
        (product.variants || []).find((v) => v.id === variantId) ||
        product.variants?.[0];
      if (!currentVariant) return;

      const rtxPlanIds = new Set(
        sellingPlanGroups.flatMap((g) =>
          (g.selling_plans || []).map((sp) => sp.id),
        ),
      );

      const selectedOrFirstAllocation =
        (currentVariant.selling_plan_allocations || []).find((a) =>
          rtxPlanIds.has(a.selling_plan_id),
        ) || null;

      const retextionDataObj = {
        product,
        currentVariant,
        sellingPlanGroups,
        show_purchase_options: true,
        purchase_type_label: "Purchase Type",
        frequency_heading: "Frequency",
        one_time_purchase_label: "One Time Purchase",
        subscription_label: sellingPlanGroups[0]?.name || "Subscribe & Save",
        default_to_subscription: product.requires_selling_plan || false,
        default_to_subscription_on_variant_change:
          product.requires_selling_plan || false,
        show_subscription_details: true,
        icon_path: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M13.64 2.35C12.19 0.9 10.2 0 7.99 0C3.57 0 0 3.58 0 8C0 12.42 3.57 16 7.99 16C11.72 16 14.83 13.45 15.72 10H13.64C12.82 12.33 10.6 14 7.99 14C4.68 14 1.99 11.31 1.99 8C1.99 4.69 4.68 2 7.99 2C9.65 2 11.13 2.69 12.21 3.78L8.99 7H15.99V0L13.64 2.35Z"></path></svg>`,
        subscription_details_box_button_text: "Subscription Details",
        subscription_details_box_title: "How subscriptions work",
        subscription_details_box_content:
          "Products are automatically delivered on your schedule. No obligation, modify or cancel your subscription anytime.",
        requiresPlan: product.requires_selling_plan || false,
        selectedAllocation: null,
        selectedOrFirstAllocation,
        productFormId: "product-popup-cart-form",
      };

      const retextionStyleObj = {
        textColor: "#2E2A39",
        fontFamily: "inherit",
        fontSize: "16px",
        borderRadius: "5px",
        borderWidth: "1px",
        borderColor: "#2E2A39BF",
        selectedTextColor: "#000",
        bgColor: "#fff",
        selectedBgColor: "#f1f1f1",
        accentColor: "#000",
        widget_layout: "standard",
        subscription_label_first: false,
        display_compare_at_price: true,
        compare_at_price_first: true,
        frequencyVisible: false,
      };

      window.retextionData = retextionDataObj;
      window.retextionStyle = retextionStyleObj;

      popupSubscription.innerHTML = "";
      const widget = document.createElement("purchase-options");
      widget.id = "rtx-popup-widget";
      widget.setAttribute(
        "data-subscription-widget",
        JSON.stringify(retextionDataObj),
      );
      widget.setAttribute(
        "data-subscription-style",
        JSON.stringify(retextionStyleObj),
      );
      popupSubscription.appendChild(widget);
    }

    document.addEventListener("click", (e) => {
      const trigger = e.target.closest(".js-product-popup-trigger");
      if (!trigger || trigger.disabled) return;
      if (!trigger.closest(".collection-page")) return;
      e.preventDefault();

      const handle = trigger.dataset.popupHandle;
      const title = trigger.dataset.popupTitle || "";
      const subtitle = trigger.dataset.popupSubtitle || "";
      const badge = trigger.dataset.popupBadge || "";
      const variantId = parseInt(trigger.dataset.popupVariantId, 10);
      const image = trigger.dataset.popupImage || "";
      const price = trigger.dataset.popupPrice || "";

      popupImg.src = image;
      popupImg.alt = title;
      popupTitle.textContent = title;
      if (popupAddedName) popupAddedName.textContent = title;
      popupSubtitle.textContent = subtitle;
      popupSubtitle.hidden = !subtitle;

      if (badge) {
        popupBadge.textContent = badge;
        popupBadge.hidden = false;
      } else {
        popupBadge.textContent = "";
        popupBadge.hidden = true;
      }

      setPopupPrice(price);
      popupVariantInput.value = variantId;
      popupSubscription.innerHTML = "";
      popupForm
        .querySelectorAll('input[name="selling_plan"]')
        .forEach((el) => el.remove());
      openPopup();

      if (handle) {
        fetch(`/products/${handle}.js`)
          .then((r) => r.json())
          .then((product) => initRtxWidget(product, variantId))
          .catch(() => {});
      }
    });

    popupOverlay.addEventListener("click", closePopup);
    popupClose.addEventListener("click", closePopup);

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && productPopup.classList.contains("is-open"))
        closePopup();
    });

    popupForm.addEventListener("submit", async (e) => {
      e.preventDefault();

      const variantId = popupVariantInput.value;
      if (!variantId) return;

      const submitBtn = popupForm.querySelector('[type="submit"]');
      if (submitBtn.getAttribute("aria-disabled") === "true") return;

      submitBtn.setAttribute("aria-disabled", "true");
      submitBtn.classList.add("loading");

      const cartEl =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");
      const formData = new FormData(popupForm);
      if (!formData.get("selling_plan")) formData.delete("selling_plan");

      if (cartEl && typeof cartEl.getSectionsToRender === "function") {
        formData.append(
          "sections",
          cartEl.getSectionsToRender().map((s) => s.id),
        );
        formData.append("sections_url", window.location.pathname);
        if (typeof cartEl.setActiveElement === "function")
          cartEl.setActiveElement(document.activeElement);
      }

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "X-Requested-With": "XMLHttpRequest" },
          body: formData,
        });

        const parsedState = await response.json();

        if (parsedState.status) {
          console.error("[Popup] Cart add error:", parsedState.description);
          return;
        }

        showAddedMessage(popupTitle.textContent);

        if (cartEl && typeof cartEl.renderContents === "function") {
          cartEl.renderContents(parsedState);
        }
      } catch (err) {
        console.error("[Popup] Add to cart failed:", err);
      } finally {
        submitBtn.removeAttribute("aria-disabled");
        submitBtn.classList.remove("loading");
      }
    });

    document.addEventListener("rtx:price-update", ({ detail }) => {
      if (detail.productFormId !== "product-popup-cart-form") return;
      setPopupPrice(
        detail.isSubscription ? detail.subscriptionPrice : detail.onetimePrice,
      );
    });

    document.addEventListener("rtx:widget-hidden", ({ detail }) => {
      if (detail.productFormId !== "product-popup-cart-form") return;
      const original = popupVariantInput.closest("form")?.dataset.originalPrice;
      if (original) setPopupPrice(original);
    });
  }

  /********************************
   * Our Approach
   *******************************/
  const sectionOurApproach = document.querySelectorAll(".our-approach");

  if (sectionOurApproach.length) {
    /***** slider *****/
    function startSlider(sliderInit) {
      new Swiper(sliderInit, {
        lazy: true,
        slidesPerView: 1.1,
        spaceBetween: 6,
        loop: true,

        navigation: {
          nextEl: ".btn-next",
          prevEl: ".btn-prev",
        },

        pagination: {
          clickable: true,
          el: ".swiper-pagination",
        },
      });
    }

    function initializeSlider(slider, slideCount) {
      if (!slider) return;

      if (screenWidth <= 767 && slideCount > 1) {
        startSlider(slider);
        slider.closest(".column-slider")?.classList.add("slider-active");
      }
    }

    /***** video *****/
    function initializeVideo(columnMedia) {
      const videoElement = columnMedia.querySelector("video.video");
      if (!videoElement) return;

      const playButton = columnMedia.querySelector(".video-play");
      const soundButton = columnMedia.querySelector(".video-sound");

      videoElement.muted = true;

      const setPlayingState = (isPlaying) => {
        columnMedia.classList.toggle("is-playing", isPlaying);
      };

      const setSoundState = (isSoundOn) => {
        columnMedia.classList.toggle("is-sound-on", isSoundOn);
      };

      const togglePlay = () => {
        const isPlayingNow = !videoElement.paused && !videoElement.ended;

        if (isPlayingNow) {
          videoElement.pause();
          setPlayingState(false);
          return;
        }

        const playPromise = videoElement.play();
        setPlayingState(true);

        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(() => {
            setPlayingState(false);
          });
        }
      };

      if (playButton) {
        playButton.addEventListener("click", (event) => {
          event.preventDefault();
          togglePlay();
        });
      }

      if (soundButton) {
        soundButton.addEventListener("click", (event) => {
          event.preventDefault();

          videoElement.muted = !videoElement.muted;
          setSoundState(!videoElement.muted);
        });
      }

      videoElement.addEventListener("click", (event) => {
        event.preventDefault();
        togglePlay();
      });

      videoElement.addEventListener("pause", () => setPlayingState(false));
      videoElement.addEventListener("ended", () => setPlayingState(false));
      videoElement.addEventListener("play", () => setPlayingState(true));

      setPlayingState(false);
      setSoundState(!videoElement.muted);
    }

    sectionOurApproach.forEach((section) => {
      const slider = section.querySelector(".slider_init");
      const slideCount = section.querySelectorAll(".swiper-slide").length;

      initializeSlider(slider, slideCount);

      const mediaColumns = section.querySelectorAll(".column-media");
      mediaColumns.forEach((columnMedia) => {
        initializeVideo(columnMedia);
      });
    });
  }

  /********************************
   * Video Controls
   *******************************/
  const videoSections = document.querySelectorAll('[data-section-name="hero"]');

  if (videoSections.length) {
    function initializeVideoControls(section) {
      const controlsContainer = section.querySelector(".global-video-controls");
      if (!controlsContainer) return;

      const playButton = controlsContainer.querySelector(
        ".js-controls-play-button",
      );
      const muteButton = controlsContainer.querySelector(
        ".js-controls-mute-button",
      );

      const playIcon = controlsContainer.querySelector(
        ".js-controls-play-icon",
      );
      const pauseIcon = controlsContainer.querySelector(
        ".js-controls-pause-icon",
      );
      const muteIcon = controlsContainer.querySelector(
        ".js-controls-mute-icon",
      );
      const unmuteIcon = controlsContainer.querySelector(
        ".js-controls-unmute-icon",
      );

      const videos = section.querySelectorAll("video");
      if (!videos.length) return;

      const getActiveVideo = () => {
        return Array.from(videos).find((video) => {
          return !!(
            video.offsetWidth ||
            video.offsetHeight ||
            video.getClientRects().length
          );
        });
      };

      const setPlayingState = (isPlaying) => {
        if (playIcon && pauseIcon) {
          playIcon.style.display = isPlaying ? "none" : "block";
          pauseIcon.style.display = isPlaying ? "block" : "none";
        }
      };

      const setMutedState = (isMuted) => {
        if (muteIcon && unmuteIcon) {
          unmuteIcon.style.display = isMuted ? "block" : "none";
          muteIcon.style.display = isMuted ? "none" : "block";
        }
      };

      const togglePlay = () => {
        const activeVideo = getActiveVideo();
        if (!activeVideo) return;

        if (activeVideo.paused) {
          const allPageVideos = document.querySelectorAll("video");
          allPageVideos.forEach((video) => {
            if (video !== activeVideo) {
              video.pause();
            }
          });
          activeVideo.play();
          setPlayingState(true);
        } else {
          activeVideo.pause();
          setPlayingState(false);
        }
      };

      const toggleMute = () => {
        const activeVideo = getActiveVideo();
        if (!activeVideo) return;

        activeVideo.muted = !activeVideo.muted;
        setMutedState(activeVideo.muted);
      };

      if (playButton) {
        playButton.addEventListener("click", (event) => {
          event.preventDefault();
          togglePlay();
        });
      }

      if (muteButton) {
        muteButton.addEventListener("click", (event) => {
          event.preventDefault();
          toggleMute();
        });
      }

      videos.forEach((video) => {
        video.addEventListener("click", (event) => {
          event.preventDefault();
          togglePlay();
        });

        video.addEventListener("play", () => {
          if (video === getActiveVideo()) {
            setPlayingState(true);
          }
        });

        video.addEventListener("pause", () => {
          if (video === getActiveVideo()) {
            setPlayingState(false);
          }
        });
      });

      const handleResize = () => {
        videos.forEach((video) => {
          if (
            !(
              video.offsetWidth ||
              video.offsetHeight ||
              video.getClientRects().length
            )
          ) {
            video.pause();
            video.currentTime = 0;
            video.muted = true;
          }
        });

        const activeVideo = getActiveVideo();
        if (activeVideo) {
          setPlayingState(!activeVideo.paused);
          setMutedState(activeVideo.muted);
        }
      };

      window.addEventListener("resize", handleResize);

      const initialVideo = getActiveVideo();
      if (initialVideo) {
        setPlayingState(!initialVideo.paused);
        setMutedState(initialVideo.muted);
      }
    }

    videoSections.forEach((section) => {
      initializeVideoControls(section);
    });
  }

  /********************************
   * Info Cards
   *******************************/
  const sectionCardsInfo = document.querySelectorAll(".info-cards");

  if (sectionCardsInfo.length) {
    function initializeSlider(slider, slideCount) {
      if (screenWidth <= 991 && slideCount > 1) {
        startSlider(slider);
      }
    }

    function startSlider(sliderInit) {
      new Swiper(sliderInit, {
        lazy: true,
        slidesPerView: 1.1,
        spaceBetween: 6,

        breakpoints: {
          320: {
            slidesPerView: 1.1,
          },
          767: {
            slidesPerView: 2.1,
          },
          991: {
            slidesPerView: 2.8,
          },
        },

        scrollbar: {
          el: ".swiper-scrollbar",
          hide: true,
        },
      });
    }

    sectionCardsInfo.forEach((section) => {
      const slider = section.querySelector(".slider_init");
      const slideCount = section.querySelectorAll(".swiper-slide").length;

      initializeSlider(slider, slideCount);
    });
  }

  /********************************
   * Hero + Info Cards
   *******************************/
  const heroInfoCards = document.querySelectorAll(".hero-info-cards");

  if (heroInfoCards.length) {
    function initializeSlider(slider, slideCount, container) {
      if (screenWidth <= 992 && slideCount > 1) {
        container.classList.add("slider-active");
        startSlider(slider, container);
      }
    }

    function startSlider(sliderInit) {
      new Swiper(sliderInit, {
        lazy: true,
        slidesPerView: 1.05,
        spaceBetween: 6,
        loop: true,

        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          992: {
            spaceBetween: 10,
            slidesPerView: 3,
          },
        },

        navigation: {
          nextEl: ".btn-next",
          prevEl: ".btn-prev",
        },

        pagination: {
          clickable: true,
          el: ".swiper-pagination",
        },
      });
    }

    heroInfoCards.forEach((section) => {
      const container = section.querySelector(".container");
      const slider = section.querySelector(".slider_init");
      const slideCount = section.querySelectorAll(".swiper-slide").length;

      initializeSlider(slider, slideCount, container);
    });
  }
  document.addEventListener("rebuy:cart.change", (event) => {
    const { cart } = event.detail;
    let cartBubble = document.querySelector(".cart-count-bubble");
    if (cartBubble) {
      let spans = cartBubble.querySelectorAll("span");
      spans[0].innerHTML = cart.cart.item_count;
      spans[1].innerHTML = cart.cart.item_count + " items";
    }
  });

  /*************************
   Collection: waitlist button for storefront-only sold-out products
   (tags force-sold-out / force-sold-out:<variant id>). Rocket only renders
   its own collection button for products Shopify reports as unavailable, so
   the card renders one and opens Rocket's form through its JavaScript API:
   window._RestockRocket.openModal(productData, variantId)
   *************************/
  const waitlistButtons = document.querySelectorAll(".card-waitlist-btn");
  if (waitlistButtons.length) {
    const rocketText = window._RestockRocketConfig?.settings?.storefront_button_text;
    if (rocketText) {
      waitlistButtons.forEach((btn) => {
        btn.textContent = rocketText;
      });
    }
  }

  document.addEventListener("click", async (event) => {
    const btn = event.target.closest(".card-waitlist-btn");
    if (!btn) return;
    event.preventDefault();

    const handle = btn.dataset.waitlistHandle;
    const variantId = Number(btn.dataset.waitlistVariantId);
    const rocket = window._RestockRocket;
    const fallback = () => {
      if (btn.dataset.waitlistUrl) window.location.href = btn.dataset.waitlistUrl;
    };
    if (!handle || !rocket || typeof rocket.openModal !== "function") return fallback();

    let product = window._RestockRocketConfig?.products?.[handle]?.product;
    if (!product) {
      try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
        const res = await fetch(`${root}products/${handle}.js`, { credentials: "same-origin" });
        product = res.ok ? await res.json() : null;
      } catch (e) {
        product = null;
      }
    }
    if (!product) return fallback();
    rocket.openModal(product, variantId);
  });
});
